var _style, _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoldKeys(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "163.9px",
    height: "140px",
    viewBox: "0 0 163.9 140",
    style: {
      enableBackground: "new 0 0 163.9 140"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#989898;}\n\t.st1{fill:#B4B4B4;}\n\t.st2{fill:#818181;}\n\t.st3{fill:#979797;}\n\t.st4{fill:#5F5F5F;}\n\t.st5{fill:#B3B3B3;}\n\t.st6{fill:#A5A5A5;}\n\t.st7{fill:#909090;}\n\t.st8{fill:#525252;}\n\t.st9{fill:#7C7C7C;}\n\t.st10{fill:#A3A3A3;}\n\t.st11{fill:#A6A6A6;}\n\t.st12{fill:#3D3D3D;}\n\t.st13{fill:#565656;}\n\t.st14{fill:#5A5A5A;}\n\t.st15{fill:#BFBFBF;}\n\t.st16{fill:#A8A8A8;}\n\t.st17{fill:#686868;}\n\t.st18{fill:#969696;}\n\t.st19{fill:#626262;}\n\t.st20{fill:#6D6D6D;}\n\t.st21{fill:#494949;}\n\t.st22{fill:#939393;}\n\t.st23{fill:#BABABA;}\n\t.st24{fill:#707070;}\n\t.st25{opacity:0.2;fill:#010101;enable-background:new    ;}\n\t.st26{fill:#7A7A7A;}\n\t.st27{fill:#555555;}\n\t.st28{fill:#6F6F6F;}\n\t.st29{fill:#B2B2B2;}\n\t.st30{fill:#767676;}\n\t.st31{fill:#848484;}\n\t.st32{fill:#D1D1D1;}\n\t.st33{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\n\t.st34{fill:#DD9619;}\n\t.st35{fill:#FCB01A;}\n\t.st36{fill:#6ABD45;}\n\t.st37{fill:#ED2224;}\n\t.st38{fill:#70CDDD;}\n\t.st39{fill:#F79421;}\n\t.st40{fill:#57A0D7;}\n\t.st41{fill:#3F4DA1;}\n\t.st42{fill:#F05223;}\n\t.st43{fill:#70B2E2;}\n\t.st44{fill:#8DC641;}\n\t.st45{fill:#2E368F;}\n\t.st46{fill:#C1282D;}\n\t.st47{fill:#D41C5C;}\n\t.st48{fill:#F9AA92;}\n\t.st49{fill:#C694C3;}\n\t.st50{fill:#3374BA;}\n\t.st51{fill:#7CB342;}\n\t.st52{fill:#616261;}\n\t.st53{fill:#E53A35;}\n\t.st54{fill:#5E4137;}\n\t.st55{fill:#F37046;}\n\t.st56{fill:#FBB03B;}\n\t.st57{fill:#9B51A0;}\n\t.st58{fill:#B9539F;}\n\t.st59{fill:#6D4D42;}\n\t.st60{fill:#5E6BB2;}\n\t.st61{fill:#F9A822;}\n\t.st62{fill:#8D6E63;}\n\t.st63{fill:#679F42;}\n\t.st64{fill:#FDD837;}\n\t.st65{fill:#FFFFFF;enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "81.9,133.6 5.5,89.5 0,92.7 81.9,140 163.9,92.7 158.4,89.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.9,39L0,86.3l5.5,3.2l76.4,44.1l76.4-44.1l5.5-3.2L81.9,39z M81.9,130L6.4,86.3L82,42.6l75.6,43.7L81.9,130 z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "0,92.7 0,86.3 81.9,133.6 81.9,140  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "81.9,133.6 163.9,86.3 163.9,92.7 81.9,140  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "6.4,86.3 81.9,42.7 157.5,86.3 155,87.9 81.9,45.4 8.3,87.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "81.9,45.4 8.3,87.9 81.9,130 155,87.9  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M62.4,91.3c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C66.9,87.4,65.4,89.6,62.4,91.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M62.4,91.3c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0S68.3,87.9,62.4,91.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M62.4,88c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C66.9,84.1,65.4,86.3,62.4,88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M62.4,88c-5.9,3.4-15.4,3.4-21.3,0c-5.9-3.4-5.9-8.9,0-12.3c5.9-3.4,15.4-3.4,21.3,0 C68.3,79.1,68.3,84.6,62.4,88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M62.4,84.8c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C66.9,80.9,65.4,83.1,62.4,84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M62.4,84.8c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0S68.3,81.4,62.4,84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M62.4,81.6C56.5,85,47,85,41.1,81.6c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C66.9,77.6,65.4,79.9,62.4,81.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M62.4,81.6C56.5,85,47,85,41.1,81.6c-5.9-3.4-5.9-8.9,0-12.3c5.9-3.4,15.4-3.4,21.3,0 C68.3,72.7,68.3,78.2,62.4,81.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M62.4,78.3c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C66.9,74.4,65.4,76.6,62.4,78.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M62.4,78.3c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0S68.3,74.9,62.4,78.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M62.4,75.1c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C66.9,71.2,65.4,73.4,62.4,75.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M62.4,75.1c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3c5.9-3.4,15.4-3.4,21.3,0C68.3,66.2,68.3,71.7,62.4,75.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M62.4,71.9c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C66.9,67.9,65.4,70.2,62.4,71.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M62.4,71.9c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3c5.9-3.4,15.4-3.4,21.3,0C68.3,62.9,68.3,68.5,62.4,71.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M62.4,68.6C56.5,72,47,72,41.1,68.6c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C66.9,64.7,65.4,66.9,62.4,68.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M62.4,68.6C56.5,72,47,72,41.1,68.6s-5.9-8.9,0-12.3c5.9-3.4,15.4-3.4,21.3,0C68.3,59.7,68.3,65.2,62.4,68.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M62.4,65.4c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0V62c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C66.9,61.4,65.4,63.7,62.4,65.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M62.4,65.4c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3c5.9-3.4,15.4-3.4,21.3,0C68.3,56.5,68.3,62,62.4,65.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M62.4,62.1c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2V56C66.9,58.2,65.4,60.4,62.4,62.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M62.4,62.1c-5.9,3.4-15.4,3.4-21.3,0c-5.9-3.4-5.9-8.9,0-12.3c5.9-3.4,15.4-3.4,21.3,0 C68.3,53.2,68.3,58.7,62.4,62.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M62.4,58.9c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C66.9,55,65.4,57.2,62.4,58.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M62.4,58.9c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0C68.3,50,68.3,55.5,62.4,58.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M62.4,55.7c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 C44,60.1,47.9,61,51.8,61c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C66.9,51.7,65.4,54,62.4,55.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M62.4,55.7c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0S68.3,52.3,62.4,55.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M62.4,52.4c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0V49c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C66.9,48.5,65.4,50.7,62.4,52.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M62.4,52.4c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0S68.3,49,62.4,52.4z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,53.7c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 C74.2,58.1,78.1,59,82,59c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,49.7,95.6,52,92.6,53.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,53.7c-5.9,3.4-15.4,3.4-21.3,0c-5.9-3.4-5.9-8.9,0-12.3c5.9-3.4,15.4-3.4,21.3,0 C98.5,44.7,98.5,50.3,92.6,53.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,50.4c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0V47c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,46.5,95.6,48.7,92.6,50.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,50.4c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0C98.5,41.5,98.5,47,92.6,50.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,47.2c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2V41C97,43.2,95.6,45.5,92.6,47.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,47.2c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,43.8,92.6,47.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,43.9c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,40,95.6,42.2,92.6,43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,43.9c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,40.5,92.6,43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,40.7c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 C74.2,45.2,78.1,46,82,46c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,36.8,95.6,39,92.6,40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,40.7c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,37.3,92.6,40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,37.5c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,33.5,95.6,35.8,92.6,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,37.5c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,34.1,92.6,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,34.2c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,30.3,95.6,32.5,92.6,34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,34.2c-5.9,3.4-15.4,3.4-21.3,0c-5.9-3.4-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,30.8,92.6,34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,31c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,27.1,95.6,29.3,92.6,31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,31c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,27.6,92.6,31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,27.7c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,23.8,95.6,26,92.6,27.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,27.7c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,24.3,92.6,27.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,24.5c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,20.6,95.6,22.8,92.6,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,24.5c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,21.1,92.6,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,21.3c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,17.3,95.6,19.6,92.6,21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,21.3c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,17.9,92.6,21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,18c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,14.1,95.6,16.3,92.6,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,18c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,14.6,92.6,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,14.8c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2V8.6C97,10.9,95.6,13.1,92.6,14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,14.8c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,11.4,92.6,14.8z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M122.8,95.5c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C127.2,91.6,125.7,93.8,122.8,95.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M122.8,95.5c-5.9,3.4-15.4,3.4-21.3,0c-5.9-3.4-5.9-8.9,0-12.3s15.4-3.4,21.3,0 C128.7,86.6,128.7,92.1,122.8,95.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M122.8,92.3c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C127.2,88.4,125.7,90.6,122.8,92.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M122.8,92.3c-5.9,3.4-15.4,3.4-21.3,0c-5.9-3.4-5.9-8.9,0-12.3s15.4-3.4,21.3,0 C128.7,83.4,128.7,88.9,122.8,92.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M122.8,89.1c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C127.2,85.1,125.7,87.4,122.8,89.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M122.8,89.1c-5.9,3.4-15.4,3.4-21.3,0c-5.9-3.4-5.9-8.9,0-12.3s15.4-3.4,21.3,0 C128.7,80.1,128.7,85.7,122.8,89.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M122.8,85.8c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C127.2,81.9,125.7,84.1,122.8,85.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M122.8,85.8c-5.9,3.4-15.4,3.4-21.3,0c-5.9-3.4-5.9-8.9,0-12.3s15.4-3.4,21.3,0 C128.7,76.9,128.7,82.4,122.8,85.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M122.8,82.6c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C127.2,78.6,125.7,80.9,122.8,82.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M122.8,82.6c-5.9,3.4-15.4,3.4-21.3,0c-5.9-3.4-5.9-8.9,0-12.3s15.4-3.4,21.3,0 C128.7,73.7,128.7,79.2,122.8,82.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M122.8,79.3c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0V76c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C127.2,75.4,125.7,77.6,122.8,79.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M122.8,79.3c-5.9,3.4-15.4,3.4-21.3,0c-5.9-3.4-5.9-8.9,0-12.3s15.4-3.4,21.3,0 C128.7,70.4,128.7,75.9,122.8,79.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M122.8,76.1c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C127.2,72.2,125.7,74.4,122.8,76.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M122.8,76.1c-5.9,3.4-15.4,3.4-21.3,0c-5.9-3.4-5.9-8.9,0-12.3c5.9-3.4,15.4-3.4,21.3,0 C128.7,67.2,128.7,72.7,122.8,76.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M122.8,72.9c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C127.2,68.9,125.7,71.2,122.8,72.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M122.8,72.9c-5.9,3.4-15.4,3.4-21.3,0c-5.9-3.4-5.9-8.9,0-12.3s15.4-3.4,21.3,0 C128.7,63.9,128.7,69.5,122.8,72.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M122.8,69.6c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C127.2,65.7,125.7,67.9,122.8,69.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M122.8,69.6c-5.9,3.4-15.4,3.4-21.3,0c-5.9-3.4-5.9-8.9,0-12.3s15.4-3.4,21.3,0 C128.7,60.7,128.7,66.2,122.8,69.6z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M122.8,66.4c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0V63c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C127.2,62.4,125.7,64.7,122.8,66.4z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M122.8,66.4c-5.9,3.4-15.4,3.4-21.3,0c-5.9-3.4-5.9-8.9,0-12.3s15.4-3.4,21.3,0 C128.7,57.5,128.7,63,122.8,66.4z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,108.9c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,104.9,95.6,107.2,92.6,108.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,108.9c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,105.5,92.6,108.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,105.6c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,101.7,95.6,103.9,92.6,105.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,105.6c-5.9,3.4-15.4,3.4-21.3,0c-5.9-3.4-5.9-8.9,0-12.3c5.9-3.4,15.4-3.4,21.3,0 C98.5,96.7,98.5,102.2,92.6,105.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,102.4c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0V99c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,98.5,95.6,100.7,92.6,102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,102.4c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,99,92.6,102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,99.2c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2V93C97,95.2,95.6,97.5,92.6,99.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,99.2c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0C98.5,90.2,98.5,95.8,92.6,99.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,95.9c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,92,95.6,94.2,92.6,95.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,95.9c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,92.5,92.6,95.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,92.7c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 C74.2,97.2,78.1,98,82,98c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,88.7,95.6,91,92.6,92.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,92.7c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,89.3,92.6,92.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,89.4c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,85.5,95.6,87.7,92.6,89.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,89.4c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,86,92.6,89.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,86.2c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2V80C97,82.3,95.6,84.5,92.6,86.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,86.2c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,82.8,92.6,86.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,83c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,79,95.6,81.3,92.6,83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,83c-5.9,3.4-15.4,3.4-21.3,0c-5.9-3.4-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,79.6,92.6,83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,79.7c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 C74.2,84.2,78.1,85,82,85c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,75.8,95.6,78,92.6,79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,79.7c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0C98.5,70.8,98.5,76.3,92.6,79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,76.5c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,72.5,95.6,74.8,92.6,76.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,76.5c-5.9,3.4-15.4,3.4-21.3,0c-5.9-3.4-5.9-8.9,0-12.3c5.9-3.4,15.4-3.4,21.3,0 C98.5,67.6,98.5,73.1,92.6,76.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,73.2c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,69.3,95.6,71.5,92.6,73.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,73.2c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,69.8,92.6,73.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,70c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,66.1,95.6,68.3,92.6,70z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,70c-5.9,3.4-15.4,3.4-21.3,0c-5.9-3.4-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,66.6,92.6,70z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,95.9c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,92,95.6,94.2,92.6,95.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,95.9c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,92.5,92.6,95.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,92.7c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 C74.2,97.2,78.1,98,82,98c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,88.7,95.6,91,92.6,92.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,92.7c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,89.3,92.6,92.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,89.4c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,85.5,95.6,87.7,92.6,89.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,89.4c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,86,92.6,89.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,86.2c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2V80C97,82.3,95.6,84.5,92.6,86.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,86.2c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,82.8,92.6,86.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,83c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,79,95.6,81.3,92.6,83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,83c-5.9,3.4-15.4,3.4-21.3,0c-5.9-3.4-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,79.6,92.6,83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,79.7c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 C74.2,84.2,78.1,85,82,85c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,75.8,95.6,78,92.6,79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,79.7c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0C98.5,70.8,98.5,76.3,92.6,79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,76.5c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,72.5,95.6,74.8,92.6,76.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,76.5c-5.9,3.4-15.4,3.4-21.3,0c-5.9-3.4-5.9-8.9,0-12.3c5.9-3.4,15.4-3.4,21.3,0 C98.5,67.6,98.5,73.1,92.6,76.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,73.2c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,69.3,95.6,71.5,92.6,73.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,73.2c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,69.8,92.6,73.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,70c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,66.1,95.6,68.3,92.6,70z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,70c-5.9,3.4-15.4,3.4-21.3,0c-5.9-3.4-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,66.6,92.6,70z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,66.8c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,62.8,95.6,65.1,92.6,66.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,66.8c-5.9,3.4-15.4,3.4-21.3,0s-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,63.4,92.6,66.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,63.5c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,59.6,95.6,61.8,92.6,63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,63.5c-5.9,3.4-15.4,3.4-21.3,0c-5.9-3.4-5.9-8.9,0-12.3s15.4-3.4,21.3,0S98.5,60.1,92.6,63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,60.3c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,56.4,95.6,58.6,92.6,60.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,60.3c-5.9,3.4-15.4,3.4-21.3,0c-5.9-3.4-5.9-8.9,0-12.3c5.9-3.4,15.4-3.4,21.3,0 C98.5,51.4,98.5,56.9,92.6,60.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M92.6,57c-5.9,3.4-15.4,3.4-21.3,0c-2.9-1.7-4.4-3.9-4.4-6.2l0,0v2.8c0,2.2,1.5,4.5,4.4,6.2 c2.9,1.7,6.8,2.6,10.7,2.6c3.9,0,7.7-0.9,10.7-2.6c2.9-1.7,4.4-3.9,4.4-6.2v-2.8C97,53.1,95.6,55.3,92.6,57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M92.6,57c-5.9,3.4-15.4,3.4-21.3,0c-5.9-3.4-5.9-8.9,0-12.3c5.9-3.4,15.4-3.4,21.3,0 C98.5,48.1,98.5,53.6,92.6,57z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoldKeys);
export default __webpack_public_path__ + "static/media/sold-keys.b1f1bb1f743b9a9cecd33bd0b9d7223f.svg";
export { ForwardRef as ReactComponent };